const VisualComponent = require('./VisualComponent');

class ReferencesPopup extends VisualComponent {
    _escModals = [];
    _closeBound = null;

    #main;
    #tmpl;
    #view = {};

    /**
     * @param {Object} view - The article view object.
     * @param {function()} template - The JADE template client file.
     */
    constructor(view, template) {
        super();
        try {
            if (view.config.citations.multiRefPopup.enabled) {
                this.classNames = view.config.classNames;
                this.config = view.config.citations;
                this.s = this.config.multiRefPopup.s;
                this._escModals = view?.escapeModals || [];

                this.#view = view;
                this.#tmpl = template;

                if (this.#tmpl !== undefined) {
                    this.init();
                }
            }
        } catch (error) {
            console.error('MultiRef citation - popup:', error);
        }
    }

    init() {
        const html = this.#view.vC.stringToHTML(this.#tmpl());
        (document.body.querySelector(this.s.parent) || document.body).prepend(html);
        this.#main = document.querySelector(this.s.wrapper);

        if (this.#main) {
            this.#hide();
            this.#view.subscribeAnchorClick(this.s.citationTarget, this.#show.bind(this));
            this.#main.querySelector(this.s.close).addEventListener('click', () => this.#hide());
        }
    }
    destroy() {
        if (this.#main) this.#main.remove();
        this.#view.subscribeAnchorClick(this.s.citationTarget, this.#show.bind(this), true);
    }

    #hide() {
        if (this._escModals[this._escModals.length - 1] === this._closeBound) {
            this._escModals.pop();
            this._closeBound = null;
        }
        this.#main.classList.remove(this.classNames.SHOW);
        this.#view.vC.hideElement(this.#main);
    }
    #show(e) {
        if (!this._closeBound) {
            this._closeBound = this.#hide.bind(this);
        }
        this._escModals.push(this._closeBound);

        const list = e.currentTarget.closest(this.s.citationList);
        if (!list) {
            console.debug('ReferencesPopup::Could not find parent selector');
            return;
        }

        // toggle popup visibility
        this.#main?.classList?.add(this.classNames.SHOW);
        this.#view.vC.showElement(this.#main);

        // update the displayed elements
        const refList = this.#main.querySelector(this.s.refList);
        refList.innerHTML = list.outerHTML;
        refList.querySelectorAll(this.s.citationTarget).forEach(item => {
            if (e.currentTarget.href === item.href) {
                item.classList.add(this.classNames.ACTIVE);
            } else {
                item.classList.remove(this.classNames.ACTIVE);
            }
        });
        this.setReferenceLabel(e.currentTarget);
    }

    setReferenceLabel(ref) {
        const baseID = this.getBaseID(ref);
        const refNumber = this.#main.querySelector(this.s.refNumber);
        if (!baseID) {
            refNumber.textContent = '';
        } else {
            refNumber.textContent = baseID.match(/(\d+)/)[0];
        }
    }
    getBaseID(ref) {
        const splitted = ref.getAttribute('href').split('-');
        // eg. #core-B1-1 -> B1 (#core-[B1]-1), #core-ref-1-1 -> 1 (#core-ref-[1]-1)
        return splitted[splitted.length-2];
    }
}

module.exports = ReferencesPopup;
